import { render, staticRenderFns } from "./modalComponent.vue?vue&type=template&id=9fc06524&"
import script from "./modalComponent.vue?vue&type=script&lang=ts&"
export * from "./modalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports